/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: AlphabeticallistofproductsModule
 * Purpose		: Module for Alphabeticallistofproducts.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { AlphabeticallistofproductsService } from './Alphabeticallistofproducts.service';
import { AlphabeticallistofproductsListComponent } from './AlphabeticallistofproductsList.component';
import { AlphabeticallistofproductsSearchComponent } from './AlphabeticallistofproductsSearch.component';
import { AlphabeticallistofproductsDetailsComponent } from './AlphabeticallistofproductsDetails.component';

import { AlphabeticallistofproductsRoutingModule } from './Alphabeticallistofproducts-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    AlphabeticallistofproductsRoutingModule
  ],
  declarations: [
    AlphabeticallistofproductsListComponent,
	AlphabeticallistofproductsSearchComponent,
	AlphabeticallistofproductsDetailsComponent
  ],
  providers: [
    AlphabeticallistofproductsService
  ]
})

export class AlphabeticallistofproductsModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Alphabeticallistofproducts/Alphabeticallistofproducts.module.ts